export default state => {
  const { pagination, filters, sorting, dataProperties, views } = state;
  const view = views ? views.getActiveView() : null;

  return {
    ...(pagination ? { itemsPerPage: pagination.itemsPerPage } : {}),
    ...(filters ? { filters: filters.activeFilters } : {}),
    ...(sorting ? { sort: sorting.activeSort } : {}),
    ...(dataProperties ? { properties: dataProperties.selectedProperties } : {}),
    ...(view ? { view: view.key } : {}),
  };
};
